import React from 'react'
import cx from 'classnames'
import Footer from '../footer'
import { Link } from 'gatsby'
import BrandLogo from '../brand-logo'
import * as styles from '../../styles/components/mobile-nav.module.scss'
import { CrosshairsClosedIcon, CrosshairsOpenIcon } from '../icons/crosshairs'

interface MobileNavBarProps {
    links: Queries.NamedLinks[]
    mobileNavExpanded: boolean
    mobileNavWasToggled: boolean
    navToggleHandler: () => void
    className?: string
}

const MobileNavBar = (props: MobileNavBarProps) => {
    const { links, mobileNavExpanded, mobileNavWasToggled, navToggleHandler, className } = props

    return (
        <nav className={cx(styles.container, className)}>
            <div className={styles.brandLogoContainer}>
                <Link to="/" className={cx({ [styles.hidden]: false })} aria-label="Home">
                    <BrandLogo colorVariant={'dark'} />
                </Link>
                <button
                    className={styles.mobileMenuToggle}
                    onClick={navToggleHandler}
                    aria-label="Toggle mobile menu"
                >
                    <div className={styles.iconContainer}>
                        <div
                            className={cx(styles.openIcon, {
                                [styles.openIconHidden]: mobileNavExpanded,
                            })}
                        >
                            <CrosshairsOpenIcon />
                        </div>
                        <div
                            className={cx(styles.closeIcon, {
                                [styles.closeIconVisible]: mobileNavExpanded,
                                [styles.closeIconHidden]: !mobileNavExpanded,
                                [styles.iconAnimated]: mobileNavWasToggled,
                            })}
                        >
                            <CrosshairsClosedIcon />
                        </div>
                    </div>
                </button>
            </div>
            <div className={cx(styles.navMenu, {
                [styles.expanded]: mobileNavExpanded,
                [styles.navMenuAnimated]: mobileNavWasToggled,
            })}>
                <div className={styles.navLinkContainer}>
                    {links?.map((link) =>
                        <Link to={link.url} className={styles.navLink} key={link.name} onClick={navToggleHandler}>
                            <span
                                className={cx(styles.linkText)}
                            >
                                {link.name}
                            </span>
                        </Link>,
                    )}
                    <Footer className={styles.navFooter} />
                </div>
            </div>
        </nav>
    )
}

export default MobileNavBar
